import { render, staticRenderFns } from "./data-change-history.vue?vue&type=template&id=34363235&scoped=true"
import script from "./data-change-history.vue?vue&type=script&lang=js"
export * from "./data-change-history.vue?vue&type=script&lang=js"
import style0 from "./data-change-history.vue?vue&type=style&index=0&id=34363235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34363235",
  null
  
)

export default component.exports